import { TextareaAutosize } from "@material-ui/core";
import styled, { css } from "styled-components";

export const Header = styled.div`
  margin-bottom: 16px;
`;

export const ListRow = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  padding: 16px;
  color: #fff;

  ${(props) =>
    props.isHeader
      ? css`
          border-bottom: 0px;
          background: #031795;
        `
      : css`
          border-bottom: 1px solid #e0e0e0;
          background: #fff;
          color: #000;
        `}

  ${(props) =>
    !props.isHeader &&
    css`
      border-top: 1px solid #e0e0e0;
    `}

  div {
    display: flex;
  }
`;

export const VotingContainer = styled.div`
  display: flex;
  gap: 12px;
  padding: 16px;
  padding-left: 0px;
  border-bottom: 1px solid #e0e0e0;
  width: 100%;

  .selection-side {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    span {
      font-weight: bold;
    }

    .selection-container {
      display: grid;
      width: 100%;
      grid-template-columns: calc(100% - 54px) 48px;
      gap: 6px;
    }

    .inputs-container {
      display: flex;
      gap: 12px;
      flex-direction: column;
      justify-content: center;
    }

    .add-button-container {
      min-width: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }

  .voters-side {
    width: 70%;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;

export const ITextareaAutosize = styled(TextareaAutosize)`
  background: #fff;
  border: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  font-size: 16px;

  ${(props) =>
    props.errored &&
    css`
      border-color: #fe0000;
    `}

  ${(props) =>
    props.disabled &&
    css`
      color: #00000061;
      border-bottom: 1px dashed rgba(0, 0, 0, 0.42);
    `}

  :focus-visible {
    outline: -webkit-focus-ring-color auto 0px;
  }
`;

export const ConcludeButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
`;

export const CaveatAprroverCard = styled.div`
  padding: 4px;
  margin-left: 4px;
  margin-bottom: 4px;
  color: #ffffff;
  background-color: #465eb6;
  border: none;
  cursor: default;
  display: inline-flex;
  outline: 0;
  font-size: 0.8125rem;
  box-sizing: border-box;
  align-items: center;
  white-space: nowrap;
  border-radius: 16px;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;

  div {
    display: flex;
    flex-direction: column;

    max-width: 260px;

    span {
      padding-left: 12px;
      padding-right: 12px;
      text-overflow: ellipsis;
    }

    .caveat-title {
      margin-top: 4px;
      font-size: 14px;
      font-weight: bold;
    }

    .caveat {
      white-space: pre-wrap;
      margin-bottom: 4px;
      overflow-wrap: break-word;
      max-width: 240px;
      max-height: 100px;
      overflow-y: scroll;
    }
  }

  svg {
    color: rgba(255, 255, 255, 0.7);
    width: 22px;
    cursor: pointer;
    height: 22px;
    margin: 0 5px 0 6px;
  }
`;

export const AprroverCard = styled.div`
  padding: 4px;
  margin-left: 4px;
  margin-bottom: 4px;
  color: #ffffff;
  background-color: #465eb6;
  border: none;
  cursor: default;
  display: inline-flex;
  outline: 0;
  font-size: 0.8125rem;
  box-sizing: border-box;
  align-items: center;
  white-space: nowrap;
  border-radius: 16px;
  vertical-align: middle;
  justify-content: center;
  text-decoration: none;

  div {
    display: flex;
    flex-direction: column;

    max-width: 260px;

    span {
      padding-left: 12px;
      padding-right: 12px;
      text-overflow: ellipsis;
    }

    .date-title {
      margin-top: 4px;
      font-size: 14px;
      font-weight: bold;
    }

    .date {
      margin-bottom: 4px;
      text-overflow: ellipsis;
    }

    .caveat-title {
      margin-top: 4px;
      font-size: 14px;
      font-weight: bold;
    }

    .caveat {
      white-space: pre-wrap;
      margin-bottom: 4px;
      overflow-wrap: break-word;
      max-width: 240px;
      max-height: 100px;
      overflow-y: scroll;
    }
  }

  svg {
    color: rgba(255, 255, 255, 0.7);
    width: 22px;
    cursor: pointer;
    height: 22px;
    margin: 0 5px 0 6px;
  }
`;
